<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span i18n="@@common.company_name_profile" class="key">Company Name:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.name"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.country_profile" class="key">Country:</span>
          <span class="value">
            <gtd-ui-field-default-country [data]="data.country"></gtd-ui-field-default-country>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.activity">Activity</span>: </span>
          <gtd-ui-field-user-status [data]="data.status"></gtd-ui-field-user-status>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.system_role_profile" class="key">System Role:</span>
          <gtd-ui-field-default-string-or-empty [data]="data.system_role"></gtd-ui-field-default-string-or-empty>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.api_provider_profile" class="key">API Provider:</span>
          <gtd-ui-field-default-string-or-empty [data]="data.api_provider"></gtd-ui-field-default-string-or-empty>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.api_key_profile" class="key">API Key:</span>
          <gtd-ui-field-default-string-or-empty [data]="data.api_key"></gtd-ui-field-default-string-or-empty>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.api_url_profile" class="key">API URL:</span>
          <gtd-ui-field-default-string-or-empty [data]="data.api_url"></gtd-ui-field-default-string-or-empty>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.brand_profile" class="key">Brand:</span>
          <span class="value">
            <gtd-ui-field-default-link
              [link]="['/app/settings/crm-advertiser-brands', data?.brand?.id]"
              [displayData]="data?.brand?.name"
              [relationData]="data?.brand?.id"
              [rbacProperty]="RbacPermissionsConstant.PAGES_TABLE_ADVERTISERS"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.additional">Additional</li>
      <li>
        <p>
          <span i18n="@@common.first_name_profile" class="key">First Name:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.first_name" [fixedLength]="6"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.last_name_profile" class="key">Last Name:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.last_name" [fixedLength]="6"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.address_profile" class="key">Address:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.address" [fixedLength]="6"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.phone_profile" class="key">Phone:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.phone" [fixedLength]="6"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.skype_profile" class="key">Skype:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.skype" [fixedLength]="6"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.telegram_profile" class="key">Telegram:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.telegram" [fixedLength]="6"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.birthday_profile" class="key">Birthday:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.reference" [fixedLength]="6"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.email_profile" class="key">Email:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.email" [fixedLength]="6"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.description_profile" class="key">Description:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.description"> </gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.timestamps">Timestamps</li>
      <li>
        <p>
          <span i18n="@@common.created_at_profile" class="key">Created At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span i18n="@@common.updated_at_profile" class="key">Updated At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
